import { motion } from "framer-motion";
import { ArrowRight, Phone } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { trackClick } from "@/lib/api";
import { useContact } from "@/lib/contact";

const EASE = [0.16, 1, 0.3, 1];

export default function HeroCTA() {
    const contact = useContact();

    return (
        <motion.div
            initial={{ opacity: 0, y: 18 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: EASE, delay: 0.68 }}
            className="flex flex-wrap items-center gap-3.5"
        >
            <a
                data-testid="call-now-cta-hero"
                href={contact.telUrl}
                onClick={() => trackClick("call", "hero")}
                className="btn-gradient group inline-flex items-center gap-2.5 rounded-full px-7 py-4 text-[15px] font-bold text-white"
            >
                <Phone size={17} strokeWidth={2.6} />
                Call Now
            </a>
            <button
                data-testid="book-demo-cta-hero"
                onClick={() => scrollToId("#book-demo")}
                className="group inline-flex items-center gap-2 rounded-full border border-slate-300/90 bg-white/70 px-7 py-4 text-[15px] font-bold text-ink transition-all duration-300 hover:-translate-y-0.5 hover:border-ink/30 hover:shadow-[0_12px_28px_-14px_rgba(22,50,79,0.35)] active:scale-[0.98]"
            >
                Book a Free Demo
                <ArrowRight
                    size={16}
                    strokeWidth={2.6}
                    className="transition-transform duration-300 group-hover:translate-x-1"
                />
            </button>
        </motion.div>
    );
}
